import React from 'react';

/**
 * Banner types
 */
import Static from './containers/Static/';
import DynamicWithoutService from './containers/DynamicWithoutService/';
import DynamicSingleService from './containers/DynamicSingleService/';
import DynamicMultiService from './containers/DynamicMultiService/';
import { useConfiguration } from './providers/Configuration.js';
import BrandedOverrideStyles from './brandedOverrideStyles';

/**
 * Banner takeover layout
 */
// import Banner from './containers/Banner';
// import BannerCentered from './containers/Banner/BannerCentered';

export default function App() {
    const {
        configuration: {
            componentData: { formtype, bannerType }
        }
    } = useConfiguration();
    return (
        <>
            {bannerType === 'branded' && <BrandedOverrideStyles />}
            <FormTypeSwitch formtype={formtype} />
        </>
    );
}

function FormTypeSwitch({ formtype }) {
    switch (formtype) {
        case 'Static':
            return <Static />;
        case 'DynamicWithoutService':
            return <DynamicWithoutService />;
        case 'DynamicSingleService':
            return <DynamicSingleService />;
        case 'DynamicMultiService':
            return <DynamicMultiService />;
        default:
            return null;
    }
}
